import { Component, EventEmitter, forwardRef, Host, Input, OnInit, Optional, Output, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Log } from 'src/app/core/console.log';
import { FormControlBase } from 'src/app/shared/inputs/form-control-base';

@Component({
  selector: 'app-input-radio-check-mark',
  templateUrl: './input-radio-check-mark.component.html',
  styleUrls: ['./input-radio-check-mark.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRadioCheckMarkComponent),
      multi: true
    }
  ]
})
export class InputRadioCheckMarkComponent extends FormControlBase<number> implements OnInit {
  @Input() id;
  @Input() label;
  @Input() radioValue: any;
  @Input() labelStyleClass;
  @Input() disable;
  @Input() nameRadio;
  @Output() changed: EventEmitter<any> = new EventEmitter();
  @Output() clickRadio: EventEmitter<any> = new EventEmitter();

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
    this.checkDisabled();
  }

  checkDisabled() {
    if (this.disable == null || !this.disable) {
      this.disable = false;
    } else {
      this.disable = true;
    }
  }

  changedRadio(val) {
    Log.debug('radio-checkmark::change ', val);
    this.changed.emit(val);
  }

  onClick(event) {
    Log.debug('radio-checkmark::click ', event);
    this.clickRadio.emit(event);
  }
}
